import {
  SHOW_SNACKBAR,
  SHOW_SUCCESS_SNACKBAR,
  SHOW_GENERIC_SNACKBAR,
  RESET_SNACKBAR_MESSAGE
} from "./snackbarActionTypes";

const initialState = {
  snackBarState: false,
  snackBarMsg: "",
  snackBarSuccessState: false,
  snackBarSuccessMsg: "",
  snackBarGenericState: false,
  snackBarGenericMsg: "",
  isReset: false,
  isUndo: false,
  undoOnclick: null
};

export default function snackbarReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_SNACKBAR:
      return {
        ...state,
        snackBarState: action.snackBarStatus,
        snackBarMsg: action.resultMsg
      };

    case SHOW_SUCCESS_SNACKBAR:
      return {
        ...state,
        snackBarSuccessState: action.snackBarStatus,
        snackBarSuccessMsg: action.snackBarSuccessMsg,
        isReset: action.isReset,
        isUndo: action.isUndo,
        undoOnclick: action.undoOnclick
      };

    case SHOW_GENERIC_SNACKBAR:
      return {
        ...state,
        snackBarGenericState: action.snackBarStatus,
        snackBarGenericMsg: action.snackBarGenericMsg
      };

    case RESET_SNACKBAR_MESSAGE:
      return initialState;

    default:
      return state;
  }
}
